import React from "react";
import { publicRoute } from "../../routes/RoutePublic";
import ICImage from "../../core-component/ICImage";
import ShrinkText from "../../components/common/ShrinkText";
import { IEvent } from "../../screens/header/home-page/HomePageController";
import { useNavigate } from "react-router-dom";
import { getRelativeTime } from "../../utils/AppFunctions";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { MEDIA_TYPE } from "../../utils/AppEnumerations";
import VideoPlayer from "../../components/common/VideoPlayer";
import {
  calendarIcon,
  venueIcon,
  whiteCalendarIcon,
  whiteClockIcon,
} from "../../assets/icons/SvgIconList";
import ICPureImage from "../../core-component/ICPureImage";

interface IEventCardProps {
  item: IEvent;
}
const EventCard: React.FC<IEventCardProps> = ({ item }) => {
  const navigate = useNavigate();
  const { t } = UseTranslationHook();
  const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) {
      return text;
    } else {
      return text.substring(0, maxLength);
    }
  };
  return (
    <div className="bg-skin-insights-card rounded-lg shadow-md overflow-hidden lg:col-span-4 md:col-span-6 col-span-12 gap-6  transition-all duration-200">
      <div
        className="cursor-pointer"
        onClick={() =>
          navigate(`/${publicRoute.eventDetail}`, {
            state: { id: item.id },
          })
        }
      >
        <div className=" overflow-hidden rounded-lg border">
          {item.app_media &&
          item.app_media.length > 0 &&
          item.app_media[0].media_type === MEDIA_TYPE.image ? (
            <ICPureImage
              imageUrl={item.app_media[0]?.media_url}
              alt={item.title}
              wrapperClassName="w-full aspect-[16/9] transition-all  duration-200 hover:scale-105 hover:opacity-60"
              className="w-full aspect-[16/9] object-contain"
            />
          ) : (
            item.app_media.length > 0 && (
              <div className="aspect-[16/9]  transition-all  duration-200 hover:scale-105 hover:opacity-60">
                <VideoPlayer
                  control={[
                    "play",
                    "progress",
                    "current-time",
                    "mute",
                    "fullscreen",
                    "play-large",
                  ]}
                  source={item.app_media[0].media_url}
                />
              </div>
            )
          )}
        </div>
      </div>
      <div className="p-4">
        <div className="text-3xl font-semibold text-skin-title-insights mt-4 mb-2">
          {item.title}
        </div>
        <div className="text-sm text-justify text-skin-dec-insights mb-4">
          {truncateText(item.description, 200)}...
        </div>
        <div className="text-skin-dec-insights">
          {item.event_start_date && item.event_end_date && (
            <p className="flex border-2 p-2 w-fit mt-3 rounded-lg border-[#99b5a1]">
              <div className="w-4 h-4 mr-2">{whiteCalendarIcon}</div>{" "}
              {item.event_start_date.slice(0, 10)} -{" "}
              {item.event_end_date.slice(0, 10)}
            </p>
          )}
          {item.event_start_time && item.event_end_time && (
            <p className="flex border-2 p-2 w-fit mt-3 rounded-lg border-[#99b5a1]">
              <div className="w-5 h-5 mr-2">{whiteClockIcon}</div>{" "}
              {item.event_start_time.slice(0, 5)} -{" "}
              {item.event_end_time.slice(0, 5)}
            </p>
          )}
          <div className="mt-3">
            <div className="flex border-2 p-2 w-fit mt-3 rounded-lg border-[#99b5a1]">
              <div className="w-5 h-5 mr-2">{venueIcon}</div> {item.venue}
            </div>
          </div>
          {!item.event_start_time && !item.event_end_time && (
            <p className="flex border-2 p-2 w-fit mt-3 rounded-lg comman-border">
              <div className="w-5 h-5">{whiteClockIcon}</div>
              {item.event_start_date.slice(0, 10)} -{" "}
              {item.event_end_date.slice(0, 10)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventCard;
